<div class="billing-profile-wrapper">
    <div class="billing-profile-iframe-container">
        <div *ngIf="spinner" class="spinner">
            <sync-spinner></sync-spinner>
        </div>
        <iframe #iframe scrolling="no" *ngIf="profileSafeUrl" [style.visibility]="(!spinner && !error) ? 'visible' : 'hidden'"
            class="billing-profile" [src]="profileSafeUrl"
            sandbox="allow-forms allow-popups allow-scripts allow-same-origin"></iframe>
    </div>
    <div class="billing-profile-info" *ngIf="user.is_on_trial">
        <div class="trial-info body-1">
            <div class="trial-info-content subtitle-1">
                {{planName}}
            </div>
            <div class="trial-info-content">
                {{currentTerm | titlecase}}
            </div>
            <div *ngIf="userService.checkPermission(permissionActions.MANAGE_BILLING)" class="trial-info-content">
                <a class="" (click)="onUpgradeClick()">
                    Change plan
                </a>
            </div>
            <div *ngIf="userService.checkPermission(permissionActions.VIEW_BILLING) && planExpiry"
                class="trial-info-content">
                <ng-container *ngIf="!cancelInFuture">
                    Trial ends on {{planExpiry | date: 'MMMM d, yyyy'}}
                </ng-container>
            </div>

            <sync-divider></sync-divider>

            <div class="trial-info-content">
                <span class="body-bold-1">Reminder:</span> Add your credit card details before your trial ends to avoid
                service disruption. You won't be charged until your trial ends and you can cancel anytime.
            </div>

            <sync-divider></sync-divider>

            <div class="trial-info-content">
                <span class="body-bold-1">Questions?</span>
                <a href="https://www.sync.com/support"> Contact us </a>
            </div>
        </div>
    </div>
</div>
<sync-dialog
    [config]="{
        title: 'Delete billing profile',
        isClosable: true,
        actionButton: 'Delete profile',
        cancelButton: 'Cancel',
        onCancelClick: closeDeleteDialog,
        onActionClick: deleteProfile,
        isButtonLoading: isDeletingProfile,
    }"
    [open]="showDeleteProfileDialog"
    [onClose]="closeDeleteDialog"
    [isCritical]="true">
    <div class="delete-profile-modal-wrapper">
        <app-error *ngIf="error" [errcode]="error"></app-error>
        This will delete your billing profile.
        <span *ngIf="planExpiry">You will be sent a manual renewal notice on
            {{planExpiry | date: 'MMMM d, yyyy'}}
        </span>
    </div>
</sync-dialog>